module.exports = __webpack_public_path__ + "static/media/marcasSanitarios.ed4ce1be.jpg";